import Users from "@/views/admin/user/Users";

export default {
  path: "users/list",
  name: "users",
  component: Users,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
